import Vue from 'vue';
import store from '../store';
import { gsap } from 'gsap';
import SplitText from '../gsap-bonus/SplitText';

Vue.component('story-component', {
    props: {
        storyPart: {
            value: Number
        },
        storyNumber: {
            value: Number
        },
        maxTextCount: {
            value: Number
        },
        stopSounds: {
            value: Array
        },
        playSounds: {
            value: Array
        },
        fadeoutSounds: {
            value: Array
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            store,
            settings: store.settings,
            stories: store.stories,
            showMobileText: false,
            textCount: 0,
            currentStoryTexts: null,
            openTips: false,
            textAnimating: false,
            revealDelay: 0.5,
            splits: [],
            splitLinesInner: [],
            previousDisabledClass: {
                'disabled' : this.textCount == 0 && this.storyPart == 1
            }
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        var retrievedObject = localStorage.getItem("settings");
        this.settings = JSON.parse(retrievedObject);
        this.settings.animal = this.settings.animal.toLowerCase()

        this.store.setStoryIndex(this.storyNumber - 1);
        
        EventBus.$on('story-part:show-' + this.storyPart, () => {
            if (!this.videoPlaying && this.$refs.video) {
                this.$refs.video.play();
            }

            Vue.nextTick(() => {
                const el = this.$el.querySelector('.story__text.visible');
                this.splitTextReveal(el);

                Vue.nextTick(() => {
                    this.checkDataSounds(el)
                });
            });

            if (this.stopSounds) {
                EventBus.$emit('stop-sound', this.stopSounds);
            }

            if (this.playSounds) {
                EventBus.$emit('play-sound', this.playSounds);
            }

            if (this.fadeoutSounds) {
                EventBus.$emit('fadeout-sound', this.fadeoutSounds);
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        splitLines(el) {
            if (!this.splits[this.textCount]) {
                const split = new SplitText(el, {
                    type: 'lines',
                    linesClass: 'split-line'
                });

                this.splits.push(split);

                const lineLength = this.splits[this.textCount].lines.length;
                for (let index = 0; index < lineLength; index++) {
                    const line = this.splits[this.textCount].lines[index];
                    let inner = line.innerHTML;
                    inner = `<div class="split-line__inner">${inner}</div>`;
                    line.innerHTML = inner;
                    line.style.overflow = 'hidden';
                }
            }

            if (!this.splitLinesInner[this.textCount]) {
                this.splitLinesInner.push([...el.querySelectorAll('.split-line__inner')]);
            }
            
            gsap.set(this.splitLinesInner[this.textCount], { y: `100%`, opacity: 0 });
        },

        splitTextReveal(el) {
            this.textAnimating = true;
            
            setTimeout(() => {
                this.splitLines(el);
                window.addEventListener('resize', this.splits[this.textCount].resize);
                gsap.set(el, { opacity: 1, ease: 'power2.out' });
                gsap.to(this.splitLinesInner[this.textCount], { y: `0%`, duration: 0.75, opacity: 1, stagger: 0.2, ease: 'power2.out', onComplete: () => {
                    this.textAnimating = false;
                }});
            }, this.revealDelay * 1000);
        },

        showNextText() {
            const el = this.$el.querySelector('.story__text.visible');
            gsap.to(el, { duration: 0.75, opacity: 0, ease: "power2.out", onComplete: () => {
                this.textCount++;
                Vue.nextTick(() => {
                    const el = this.$el.querySelector('.story__text.visible');
                    this.splitTextReveal(el);

                    Vue.nextTick(() => {
                        this.checkDataSounds(el)
                    });
                });

            }});
        },

        checkDataSounds(el) {
            const playSound = el.dataset.playSound;
            if (playSound) {
                setTimeout(() => {
                    EventBus.$emit('play-sound', JSON.parse(playSound));
                }, 500);
            }
            const stopSound = el.dataset.stopSound;
            if (stopSound) {
                setTimeout(() => {
                    EventBus.$emit('stop-sound', JSON.parse(stopSound));
                }, 500);
            }
            const fadeoutSound = el.dataset.fadeoutSound;
            if (fadeoutSound) {
                setTimeout(() => {
                    EventBus.$emit('fadeout-sound', JSON.parse(fadeoutSound));
                }, 500);
            }
        },

        showPreviousText() {
            const el = this.$el.querySelector('.story__text.visible');
            gsap.to(el, { duration: 0.75, opacity: 0, ease: "power2.out", onComplete: () => {
                this.textCount--;
                Vue.nextTick(() => {
                    const el = this.$el.querySelector('.story__text.visible');
                    this.splitTextReveal(el);
                });
            }});
        },  
        
        nextText() {
            // Next text.
            if (this.textCount < this.maxTextCount) {
                console.log(`STORYPART: ${ this.storyPart }`);
                this.showNextText();
                return;
            }

            // Next page.
            if (!this.$root.book) {
                console.error('Book instance not found');
            }

            this.showPage('next', this.storyPart + 1);
            
            // Go to ending. See toEnd().
        },

        showPage(method, page) {
            const el = this.$el.querySelector('.story__text.visible');
            gsap.to(el, { duration: 0.75, opacity: 0, ease: "power2.out"});
            if (this.$refs.video) {
                this.$refs.video.pause();
            }

            this.$root.book[method](() => {
                EventBus.$emit('story-part:show-' + page);
                console.log('emit: story-part:show-' + page);
            });
        },

        toEnd() {
            if (this.textCount < this.maxTextCount) {
                console.log(`STORYPART: ${ this.storyPart }`);
                this.showNextText();
                return;
            }

            page('/stories/story-'+this.storyNumber+'-end');
        },

        prevText() {
            if (this.textCount > 0) {
                this.showPreviousText();
                return;
            }

            if (this.$root.book && this.storyPart > 1) {
                this.showPage('prev', this.storyPart - 1);
            }

            if (this.storyPart == 1) {
                page(`/stories/story-${this.storyNumber}-intro`);
            }
        },

        mediaSource: function (part = null, housing = false) {

            function translate(prop, value = null) {
                const colors = {
                    'look-1': 'bruin',
                    'look-2': 'groen',
                    'look-3': 'zalm',
                    'look-4':  'roze'
                }

                const house = {
                    'Vrijstaand huis': 'vrijstaand',
                    'Rijtjeshuis': 'rijtjeshuis',
                    'Appartement': 'flat'
                }

                const gender = {
                    'boy': 'jongen',
                    'girl': 'meisje'
                }
                
                const time = {
                    'day': 'dag',
                    'night': 'nacht'
                }

                if (prop == 'look') {
                    return colors[value];
                }

                if (prop == 'gender') {
                    return gender[value];
                }

                if (prop == 'house') {
                    return house[value];
                }

                if (prop == 'time') {
                    return time[value];
                }

                return value;
            }

            const prefix = this.storyNumber > 2 ? '' : '0';

            if (housing) {
                return `/storage/videos/verhaal-${ this.storyNumber }/${ prefix }${ part || this.storyPart }_${ translate('look', this.settings.look) }_${ translate('gender', this.settings.gender) }_${ translate('house', this.settings.house) }.mp4`;
            }

            return `/storage/videos/verhaal-${ this.storyNumber }/${ prefix }${ part || this.storyPart }_${ translate('look', this.settings.look) }_${ translate('gender', this.settings.gender) }.mp4`;
        },

        mediaSourceDayNight(part = null) {
            function translate(prop, value = null) {
                const colors = {
                    'look-1': 'bruin',
                    'look-2': 'groen',
                    'look-3': 'zalm',
                    'look-4':  'roze'
                }

                const house = {
                    'Vrijstaand huis': 'vrijstaand',
                    'Rijtjeshuis': 'rijtjeshuis',
                    'Appartement': 'flat'
                }

                const gender = {
                    'boy': 'jongen',
                    'girl': 'meisje'
                }
                
                const time = {
                    'day': 'dag',
                    'night': 'nacht'
                }

                if (prop == 'look') {
                    return colors[value];
                }

                if (prop == 'gender') {
                    return gender[value];
                }

                if (prop == 'house') {
                    return house[value];
                }

                if (prop == 'time') {
                    return time[value];
                }

                return value;
            }

            const prefix = this.storyNumber > 2 ? '' : '0';

            return `/storage/videos/verhaal-${ this.storyNumber }/${ prefix }${ part || this.storyPart }_${ translate('look', this.settings.look) }_${ translate('gender', this.settings.gender) }_${ translate('time', this.settings.time )}.mp4`;
        }
    },

    beforeDestroy() {
        EventBus.$off('story-part:show-' + this.storyPart);

        for (let index = 0; index < this.splits.length; index++) {
            const split = this.splits[index];
            window.removeEventListener('resize', split.resize);
        }
    }
});
